import PropTypes from 'prop-types';

import useRequest from 'core/hooks/useRequest';
import { bebop as bebopApi } from 'core/api/definitions/bebop';

import Feed from 'core/components/Feed';
import Loader from 'core/components/Loader';

import modelPropTypes, { topicAttributes } from 'core/utils/prop-types/model';
import { denormalizeData } from 'core/utils/api';

function Popular(props) {
  const {
    topics: outerTopics,
    /* eslint-disable react/prop-types */
    limit,
    sort,
    include,
    fields,
    days_period: daysPeriod,
    /* eslint-enable react/prop-types */
    renderer: Renderer,
    enableSSR,
    ...rendererProps
  } = props;

  const noOuterTopics = !outerTopics?.length;

  const { data, isLoading } = useRequest({
    queryKey: ['bebopApi', 'getTopics', {
      limit,
      sort,
      include,
      fields,
      days_period: daysPeriod,
    }],
    queryFn: ({ queryKey: [, method, params] }) => bebopApi[method](params),
    select: denormalizeData,
    enabled: noOuterTopics && (enableSSR || process.env.BROWSER_RUNTIME),
  });

  // TODO: почему-то при передаче топиков снаружи залипает isLoading,
  // хотя не должен. Поэтому приходится дополнительно проверять noOuterTopics.
  // Разобраться, почему так
  if (isLoading && noOuterTopics) return <Loader />;

  const topics = noOuterTopics ? data : outerTopics;

  return (
    <Renderer
      content={topics}
      {...rendererProps}
    />
  );
}

Popular.propTypes = {
  topics: PropTypes.arrayOf(modelPropTypes(topicAttributes)),

  /** Компонент, который будет рендерить карточки (Feed, Drum, etc.) */
  renderer: PropTypes.func,

  /**
   * Если данные для блока не переданы в props.topics, запрашивать их
   * при рендере на сервере.
   * Использование этого параметра может замедлить SSR!
   */
  enableSSR: PropTypes.bool,
};

Popular.defaultProps = {
  renderer: Feed,
};

export { Popular as StorybookComponent };
export default Popular;
